export const prodApi = 'https://api-server-ccrikncelx.now.sh';

export const apiDev = 'http://localhost:3001';



// WEBPACK FOOTER //
// ./src/utils/config.js